export const TableBody = (props) => {
    const { children } = props;
    return (
        <tbody className="divide-y divide-gray-200 bg-white">
            { children }
        </tbody>
    )
}